import {
    _getStartStyle,
    _getElStyle,
    _showClearIcon,
    _hideClearIcon,
    _getInputElStyle,
    getInputWid,
    goClearInputIcon,
    goErrorInputIcon,
    _getMaxLengthAttr,
    _getDisabledAttr,
    _getDisabledClass,
    _removeValidationInfo,
} from "./Common_Fun";

import {AssertUtils} from "goingutils";

let CommonInputCtl = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        if (formType === "singleQuery") {
            return this.getSingleQueryHtml(item, targetObj);
        } else {
            return this.getEditorHtml(item, targetObj);
        }
    },
    /**
     * 获取但条件查询下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getSingleQueryHtml: function (
        {label, id, required, defVal = ""},
        targetObj
    ) {
        return ` <input class="search-ipt pull-left" type="text" id="${
            targetObj.prefixCls
            }_${id}">`;
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getEditorHtml: function (
        {
            label,
            id,
            extendClass="",
            required,
            defVal = "",
            maxlength = 0,
            readOnly,
            disabled,
            width = "input-medium",
            labelWidth = "md",
            inputWidth = "auto"
        },
        targetObj,elType='text'
    ) {
        return `<div class="row  go-form-row flex-div"><div class="go-label" style="${_getElStyle(targetObj)}">
                    <span class="start-require" ${_getStartStyle({required},targetObj)}>*</span>${label}：
                </div> 
                <div class="go-content ${getInputWid(inputWidth)}" style="position: relative">
                     <div class="input_div" style="float:left">
                     <input style="${_getInputElStyle(targetObj)}" :label="label"  ${_getMaxLengthAttr(maxlength)} value="${defVal}" id="${targetObj.prefixCls}_${id}" type="${elType}"  ${_getDisabledAttr(readOnly, disabled)}
                       class="go-common-input form-control padding-l-bs  ${extendClass} ${_getDisabledClass(readOnly, disabled)}">
                    </div>
                      ${goClearInputIcon(targetObj, id)} 
                      ${goErrorInputIcon(targetObj, id)}   
                </div></div>`;
    },
    clearData(item, formType, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val("");
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            this.getQuerySubmitData(item, targetObj, backJson);
        } else {
            this.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    getQuerySubmitData: function (item, targetObj, backJson) {
        //如果不为空的情况下才返回查询的值
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        if (AssertUtils.isNotEmpty($("#" + inputElId).val())) {
            if (AssertUtils.isNotEmpty(item.queryType)) {
                backJson[item["id"] + "_" + item.queryType] = $(
                    "#" + inputElId + "_start"
                ).val();
            } else {
                backJson[item["id"]] = $("#" + inputElId).val();
            }
        }
    },
    getEditorSubmitData: function (item, targetObj, backJson) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        backJson[item["id"]] = $("#" + inputElId).val();
    },
    setValue(prop, propValue, item, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val(propValue);
    },
    //获取显示值
    getShowValue(curVal) {
        return curVal;
    },
    getRealValue(value) {
        return value || " ";
    },
    initCtlEvent: function (
        parentObj,
        inputWidth,
        targetObj,
        vueObj
    ) {
        //如果鼠标移入 当值不为空 则显示清空图标
        $(parentObj).find(".go-common-input").each((index,itemObj)=>{
            let inputId = $(itemObj).attr("id");
            $(itemObj).mouseover(function () {
                let elVal = $(`#${inputId}`).val();
                if(AssertUtils.isNotEmpty(elVal)){
                    _showClearIcon(inputId,parentObj);
                }
            }).mouseleave(function () {
                _hideClearIcon(inputId);
            });
        });

        //普通输入框的输入事件
        $(parentObj).find(".go-common-input")
            .on("input", function () {
                let val = $(this).val();let inputId=$(this).attr("id");
                //如果存在值 则显示清空图标
                if (val.length > 0) {
                    _removeValidationInfo($(this).attr("id"));
                    _showClearIcon(inputId,parentObj);
                }
            });

        //普通输入框的change事件
        $(parentObj)
            .find(".go-common-input")
            .on("change", function () {
                let elId = $(this).attr("id");
                elId = elId.replaceAll(targetObj.prefixCls + "_", "");
                //触发组件的change事件
                if (vueObj != null) {
                    vueObj.$emit("change", {
                        value: $(this).val(),
                        id: elId,
                        elObj: $(this)
                    });
                }
            });
    }
};

export default CommonInputCtl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/js-input.js